jQuery(document).ready(function(){
  jQuery('.sidebar-tags--list').each(function(){

    var LiN = jQuery(this).find('li').length;

    if( LiN > 11){    
      jQuery('li', this).eq(10).nextAll().hide().addClass('toggleable');
      jQuery(this).append('<li class="more">More...</li>');    
    }

  });


  jQuery('.sidebar-tags--list').on('click','.more', function(){

    if( jQuery(this).hasClass('less') ){    
      jQuery(this).text('More...').removeClass('less');    
    }else{
      jQuery(this).text('Less...').addClass('less'); 
    }

    jQuery(this).siblings('li.toggleable').slideToggle();

  }); 
  
  jQuery("a").on('click', function(event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      jQuery('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
        window.location.hash = hash;
      });
    } // End if
  });
  
  var backToTopbtn = $('#backToTopbtn');

  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      backToTopbtn.addClass('show');
    } else {
      backToTopbtn.removeClass('show');
    }
  });

  backToTopbtn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
  });

  jQuery('.site-header-button--subscribe').on('click', function() { 
    var $siteMob = jQuery('.site-mobile-nav');
	if ($siteMob.hasClass('scroll-lock')) {
		$siteMob.removeClass('visible');
    }
    var $bod = jQuery('body');
	if ($bod.hasClass('scroll-lock')) {
		$bod.removeClass('scroll-lock');
    }
  });
  
  /* Remove attribute on mobile as the megamenu is not needed and stops first click from linking */
  jQuery('.mobile-nav-content .navmenu-id-games').removeAttr('data-navmenu-parent');
  
});
